import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
   highlight: '#c24bfa',
   cells: '#444',
   bg: '#222',
   text: '#EEE',
}

export default theme
